import { render, staticRenderFns } from "./ChangeOfNomineeDirector.vue?vue&type=template&id=2571f94e&scoped=true&"
import script from "./ChangeOfNomineeDirector.vue?vue&type=script&lang=js&"
export * from "./ChangeOfNomineeDirector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2571f94e",
  null
  
)

export default component.exports